import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import BatchActionForm from '../BatchForm/BatchActionForm';
import Dialog from '../Dialog';

const BatchActionDialog = ({
  action,
  actionConfig,
  code,
  isOpen,
  onClose,
  onSubmit,
  reference,
  title,
}) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Box py={2}>
        <BatchActionForm
          action={action}
          batchReference={reference}
          config={actionConfig}
          code={code}
          onCancel={onClose}
          onSubmit={onSubmit}
          lockAction
        />
      </Box>
    </DialogContent>
  </Dialog>
);

BatchActionDialog.propTypes = {
  action: PropTypes.object,
  actionConfig: PropTypes.object,
  code: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  reference: PropTypes.string,
  title: PropTypes.string,
};

BatchActionDialog.defaultProps = {
  action: {},
  actionConfig: {},
  code: null,
  isOpen: false,
  onClose: undefined,
  onSubmit: undefined,
  reference: undefined,
  title: 'Batch action',
};

export default BatchActionDialog;
